export default __webpack_public_path__ + "static/media/plan-s3.b076cdfb.svg";